import { render, staticRenderFns } from "./LspregcamionGrid.vue?vue&type=template&id=4cc6cb72"
import script from "./LspregcamionGrid.vue?vue&type=script&lang=js"
export * from "./LspregcamionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports